module.exports = __webpack_public_path__ + "img/yaoqingwoman.c87f0a06.png";